import React, { useState, useEffect } from 'react';
import { Bot, X, Maximize2, Minimize2 } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { ChatInterface } from './ChatInterface';

export function FloatingResearchAssistant() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  // Check if current route should show assistant
  const isPublicRoute = ['/', '/login', '/signup'].includes(location.pathname);

  useEffect(() => {
    // Check initial auth state
    supabase.auth.getSession().then(({ data: { session } }) => {
      setIsAuthenticated(!!session);
    });

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setIsAuthenticated(!!session);
    });

    return () => subscription.unsubscribe();
  }, []);

  // Don't render anything on public routes or when not authenticated
  if (isPublicRoute || !isAuthenticated) {
    return null;
  }

  return (
    <div className={`fixed bottom-4 right-4 z-50 transition-all duration-200 ease-in-out ${
      isOpen ? 'w-96' : 'w-auto'
    }`}>
      {isOpen ? (
        <div className={`bg-white rounded-lg shadow-xl transition-all duration-200 ease-in-out ${
          isMinimized ? 'h-12' : 'h-[600px]'
        }`}>
          <div className="flex items-center justify-between p-3 border-b border-gray-200">
            <div className="flex items-center space-x-2">
              <Bot className="h-5 w-5 text-indigo-600" />
              <span className="font-medium text-gray-900">Research Assistant</span>
            </div>
            <div className="flex items-center space-x-2">
              <button
                onClick={() => setIsMinimized(!isMinimized)}
                className="p-1 hover:bg-gray-100 rounded-full"
              >
                {isMinimized ? (
                  <Maximize2 className="h-4 w-4 text-gray-500" />
                ) : (
                  <Minimize2 className="h-4 w-4 text-gray-500" />
                )}
              </button>
              <button
                onClick={() => setIsOpen(false)}
                className="p-1 hover:bg-gray-100 rounded-full"
              >
                <X className="h-4 w-4 text-gray-500" />
              </button>
            </div>
          </div>
          {!isMinimized && (
            <div className="h-[calc(100%-48px)]">
              <ChatInterface />
            </div>
          )}
        </div>
      ) : (
        <button
          onClick={() => setIsOpen(true)}
          className="bg-indigo-600 text-white p-3 rounded-full shadow-lg hover:bg-indigo-700 transition-colors flex items-center space-x-2"
        >
          <Bot className="h-6 w-6" />
          <span className="font-medium">Ask Assistant</span>
        </button>
      )}
    </div>
  );
}